<template>
    <div class="slideshow">
        <!--<div>-->
        <!--<div v-for="src in list" :key="src.name">-->
        <!--<jumbo-image v-for="src in list" :key="src.name" :src="src" :index="index" ref="slide" class="slide" @next="next()" @progress="progress"/>-->
        <!--<div v-for="src in list" :key="src.name" ref="slide" xclass="slide">bbb</div>-->
        <!--</div>-->
        <!--</div>-->
        <div>
            <slide v-for="src in list" :key="src.name" :src="src" :index="index" ref="slide" @next="next()" @progress="progress" @loaded="loaded()"/>
            <!--<img class="slide" src="/static/img/projects/battleboats01.jpg"/>-->
            <!--<img class="slide" src="/static/img/projects/battleboats01.jpg"/>-->
            <!--<img class="slide" src="/static/img/projects/battleboats01.jpg"/>-->

            <!--<video autoplay muted playsinline class="slide" ref="video">-->
            <!--<source src="/static/img/projects/battleboats.mp4"/>-->
            <!--</video>-->
        </div>

        <div class="label"><strong>{{currentSlide ? currentSlide.src.year : ''}}</strong> {{currentSlide ? currentSlide.src.label : ''}}</div>
        <div class="progress" ref="progress"></div>
    </div>
</template>

<script>
    import Slide from "./Slide";

    const listDesktop = [
        [
            {type: 'video', name: 'tap-a-zombie.mp4', label: 'Tap-A-Zombie', year:'2020', link:'2020-tap-a-zombie'},

        ],
        [
            {type: 'image', name: 'hotspot1.jpg', label: 'HotSpot AR Prototype', year:'2018', link:'2018-hotspot'},
            {type: 'video', name: 'hotspot1.mp4', label: 'HotSpot AR Prototype', year:'2018', link:'2018-hotspot'},
            {type: 'image', name: 'hotspot2.jpg', label: 'HotSpot AR Prototype', year:'2018', link:'2018-hotspot'},
            {type: 'image', name: 'hotspot3.jpg', label: 'HotSpot AR Prototype', year:'2018', link:'2018-hotspot'},

        ],
        [
            {type: 'image', name: 'maximalaufgeladen01.jpg', label: 'smart electric challenge', year:'2018', link:'2018-maximalaufgeladen'},
            {type: 'video', name: 'maximalaufgeladen.mp4', label: 'smart electric challenge', year:'2018', link:'2018-maximalaufgeladen'},
            {type: 'image', name: 'maximalaufgeladen03.jpg', label: 'smart electric challenge', year:'2018', link:'2018-maximalaufgeladen'},

        ],
        [
            {type: 'image', name: 'soundboard1.jpg', label: 'Soundboard', year:'2018', link:'2018-soundboard'},
            {type: 'video', name: 'soundboard1.mp4', label: 'Soundboard', year:'2018', link:'2018-soundboard'},
            {type: 'image', name: 'soundboard2.jpg', label: 'Soundboard', year:'2018', link:'2018-soundboard'},

        ],
        [
            {type: 'image', name: 'cheops01.jpg', label: 'Cheops Adventure', year:'2015', link:'2015-cheops'},
            {type: 'video', name: 'cheops.mp4', label: 'Cheops Adventure', year:'2015', link:'2015-cheops'},
            {type: 'image', name: 'cheops02.jpg', label: 'Cheops Adventure', year:'2015', link:'2015-cheops'}

        ],
        [
            {type: 'image', name: 'sunbath01.jpg', label: 'Sunbath Weather iOS App', year:'2017', link:''},
            {type: 'video', name: 'sunbath.mp4', label: 'Sunbath Weather iOS App', year:'2017', link:''},
            {type: 'image', name: 'sunbath02.jpg', label: 'Sunbath Weather iOS App', year:'2017', link:''}

        ],
        [
            {type: 'image', name: 'battleboats01.jpg', label: 'Battleboats.io', year:'2017', link:'2017-battleboats'},
            {type: 'image', name: 'battleboats02.jpg', label: 'Battleboats.io', year:'2017', link:'2017-battleboats'},
            {type: 'video', name: 'battleboats.mp4', label: 'Battleboats.io', year:'2017', link:'2017-battleboats'},
            {type: 'image', name: 'battleboats03.jpg', label: 'Battleboats.io', year:'2017', link:'2017-battleboats'}

        ],

        [
            {type: 'image', name: 'jumbled01.jpg', label: 'Jumbled.io', year:'2017', link:'2017-jumbled'},
            {type: 'video', name: 'jumbled.mp4', label: 'Jumbled.io', year:'2017', link:'2017-jumbled'},
            {type: 'image', name: 'jumbled02.jpg', label: 'Jumbled.io', year:'2017', link:'2017-jumbled'}

        ]
    ];

    /*const listMobile = [
        [
            {type: 'image', name: 'maximalaufgeladen01.jpg'},
            {type: 'image', name: 'maximalaufgeladen03.jpg'}

        ],

        [
            {type: 'image', name: 'cheops01.jpg'},
            {type: 'image', name: 'cheops02.jpg'}

        ],
        [
            {type: 'image', name: 'sunbath01.jpg'},
            {type: 'image', name: 'sunbath02.jpg'}

        ],
        [
            {type: 'image', name: 'battleboats01.jpg'},
            {type: 'image', name: 'battleboats02.jpg'},
            {type: 'image', name: 'battleboats03.jpg'}

        ],
        [
            {type: 'image', name: 'jumbled01.jpg'},
            {type: 'image', name: 'jumbled02.jpg'}

        ],
        [
            {type: 'image', name: 'supersnake01.jpg'},
            {type: 'image', name: 'supersnake02.jpg'}

        ]
    ];*/

    export default {
        name: "Slideshow",
        components: {Slide},
        data() {
            return {
                index: 0,
                slides: null,
                currentSlide: null,
                list: null

            }
        },
        methods: {
            progress(p) {
               this.$refs.progress.style.width = p + '%';
            },
            loaded() {
                this.$emit('loaded');
            },
            next() {
                const oldSlide = this.currentSlide;
                this.index++;
                if (this.index == this.slides.length) {
                    this.index = 0;
                }
                this.currentSlide = this.slides[this.index];
                this.currentSlide.show(oldSlide);
                this.$emit('nextslide', this.currentSlide.src);


            }
        },
        created() {
             const shuffle = (array) => {
                 for (let i = array.length - 1; i > 0; i--) {
                     const j = Math.floor(Math.random() * (i + 1));
                     const temp = array[i];
                     array[i] = array[j];
                     array[j] = temp;
                 }
             };


            const l0 = listDesktop;
            // const first = l0.shift();


            shuffle(l0);
            shuffle(l0);

            // l0.unshift(first);

            // const l0 = listDesktop;

            let list = [];

            for (let i = 0; i < l0.length; i++) {
                list = list.concat(l0[i]);
            }

            this.list = list;


        },
        mounted() {
            this.slides = this.$refs.slide.slice();
            this.currentSlide = this.slides[0];
            this.currentSlide.show();
            this.$emit('nextslide', this.currentSlide.src);
            this.$emit('init');
        }
    }
</script>

<style lang="scss" scoped>
    .slideshow {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: black;
    }

    .label {
        position: absolute;
        bottom: 5px;
        left: 10px;
        color:white;
        z-index:10;
        font-size: 1rem;
    }

    .progress {
        position: absolute;
        bottom: 0px;
        left: 0px;
        background-color:white;
        width:0;
        height:3px;
        z-index:8;
        opacity: 0.8;

    }

    /*.slide {*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*background-color: darkblue;*/
    /*position: relative;*/
    /*!*z-index: 5;*!*/
    /*}*/


</style>
